import axiosClient from './axiosClient';
import { IFormNote } from '~/utils/interface/note';
import { urlApiNote } from '~/utils/constants/apis';
import { IBaseResponse } from '~/utils/interface/base';

const noteApi = {
  createNote: (body: IFormNote) => {
    const url = urlApiNote.createNote;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default noteApi;
